import { Box } from '@mui/material';
import { Line, LineChart, ResponsiveContainer } from 'recharts';

/**
 * Tiny inline trend line for the KPI cards and site-ranking rows — no axes,
 * grid, tooltip, legend, or dots, just the shape of a numeric series in a fixed
 * small height. Reused across the revenue dashboard so every mini trend reads
 * the same.
 *
 * Pass a plain `number[]` (already selected from a TrendPoint series by the
 * caller — e.g. `trend.map(t => t.turnoverCents)`). Renders nothing for a
 * series of one point or fewer (a single dot conveys no trend), so callers can
 * hand it any series without guarding first.
 */
export function MiniSparkline({
  data, color = '#1976d2', height = 28, ariaLabel = 'trend',
}: {
  data: number[];
  color?: string;
  height?: number;
  ariaLabel?: string;
}) {
  if (data.length <= 1) return null;
  const chartData = data.map((value, index) => ({ index, value }));
  return (
    <Box data-testid="mini-sparkline" aria-label={ariaLabel} sx={{ width: '100%', height, minWidth: 48 }}>
      <ResponsiveContainer>
        <LineChart data={chartData} margin={{ top: 2, right: 2, bottom: 2, left: 2 }}>
          <Line
            type="monotone"
            dataKey="value"
            stroke={color}
            strokeWidth={1.5}
            dot={false}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
}
